'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action_type = require('../constants/action_type');

var initialState = {
  status: false,
  message: false
};

var sucConversionState = {
  status: 'success',
  message: 'Conversion success!'
};

var errConversionState = {
  status: 'error',
  message: 'Conversion error!'
};

var errFileState = {
  status: 'error',
  message: 'Invalid File: accept only [.dx, .jdx, .JCAMP, .RAW, .mz(X)ML, .cdf, .zip (Bruker FID folder)], [<30MB]'
};

var errMolState = {
  status: 'error',
  message: 'Invalid File: accept only [.mol], [<30MB]'
};

var warnUnknownState = {
  status: 'warning',
  message: 'Server not available!'
};

var buildPredictNotice = function buildPredictNotice(state, action) {
  if (!action.payload) return warnUnknownState;
  var outline = action.payload.outline;
  var code = outline.code,
      text = outline.text;

  var status = code <= 299 ? 'success' : 'error';
  if (code) {
    return Object.assign({}, state, {
      status: status,
      message: text
    });
  }
  return warnUnknownState;
};

var noticeReducer = function noticeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _action_type.FILE.ADD_FAIL:
      return Object.assign({}, state, errFileState);
    case _action_type.MOL.ADD_FAIL:
      return Object.assign({}, state, errMolState);
    case _action_type.FILE.CONVERT_DONE:
    case _action_type.MOL.CONVERT_DONE:
      return Object.assign({}, state, sucConversionState);
    case _action_type.FILE.CONVERT_FAIL:
    case _action_type.MOL.CONVERT_FAIL:
      return Object.assign({}, state, errConversionState);
    case _action_type.PREDICT.PREDICT_DONE:
    case _action_type.PREDICT.PREDICT_FAIL:
    case _action_type.PREDICT.ADD_PRED_JSON_INIT:
      return buildPredictNotice(state, action);
    case _action_type.NOTICE.MANUAL_CLEAR:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

exports.default = noticeReducer;